import type { FaireProductEntity } from "../../entity_types/product";

export const p_jqhufcxcct: FaireProductEntity = {
  token: "p_jqhufcxcct",
  type: "product",
  name: "Pink Petals Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/29ca492afbc5ca2d8e314f64a4d1bb9329b081d7d7d7485bb2d97b7c1f796c71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7cf32f52805b95fab3de934cbc00e04589fc2de998a36b8fd14625946a3c898.jpeg",
    "https://cdn.faire.com/fastly/4959afb7efbcebed5801100caa280f24e6a732345e260fc4fb4824d2a241fdf1.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:07.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
